import { Slot } from "@radix-ui/react-slot"
import { cva, VariantProps } from "class-variance-authority"
import React, { RefObject } from "react"

import { cn } from "@/utils/tailwind"

function getHeadingType(heading: NonNullable<VariantProps<typeof headingVariants>["size"]>) {
  switch (heading) {
    case 1: {
      return "h1"
    }
    case 2: {
      return "h2"
    }
    case 3: {
      return "h3"
    }
    case 4: {
      return "h4"
    }
    case 5: {
      return "h5"
    }
    case 6: {
      return "h6"
    }
  }
}

const headingVariants = cva("font-semibold text-slate-700", {
  variants: {
    size: {
      1: "text-4xl",
      2: "text-2xl",
      3: "text-xl",
      4: "text-lg",
      5: "text-base",
      6: "text-sm",
    },
  },
  defaultVariants: {},
})

interface Props extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingVariants> {
  asChild?: boolean
  order?: VariantProps<typeof headingVariants>["size"]
  ref?: RefObject<HTMLHeadingElement>
}

export function Heading({ className, size, order, asChild = false, children, ref, ...props }: Props) {
  const Comp = asChild ? Slot : getHeadingType(order ?? size ?? 1)
  return (
    <Comp className={cn(headingVariants({ className, size: size ?? order ?? 1 }))} ref={ref} {...props}>
      {children}
    </Comp>
  )
}
